import { createUseStyles } from 'react-jss';
import { DESKTOP_FONT_SIZES, DESKTOP_SIZES_BREAKPOINT, GLOBAL_LETTER_SPACING, MOBILE_FONT_SIZES, } from '@/styles/themes/components';
import { blendHexColor } from '@/libs/helpers';
export const useStyles = createUseStyles((theme) => ({
    flight: {
        display: 'flex',
        flexDirection: 'column',
        '& > div': {
            marginBottom: '6px',
        },
        marginTop: '14px',
        [theme.breakpoints.up('lg')]: {
            marginTop: '0px',
            '& > div': {
                marginBottom: '6px',
            },
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: '0px 6px',
            '& > div:nth-child(1)': {
                gridColumn: '1 / 4',
            },
            '& > div:nth-child(2)': {
                gridColumn: '4 / 7',
            },
            '& > div:nth-child(3)': {
                gridColumn: '1 / 3',
            },
            '& > div:nth-child(4)': {
                gridColumn: '3 / 5',
            },
            '& > div:nth-child(5)': {
                gridColumn: '5 / 7',
            },
            '& > div:nth-child(6)': {
                gridColumn: '1 / 3',
            },
            '& > div:nth-child(7)': {
                gridColumn: '3 / 5',
            },
            '& > div:nth-child(8)': {
                gridColumn: '5 / 7',
            },
        },
    },
    flightHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
    },
    flightSubtitle: {
        marginTop: 8,
    },
    flightActions: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexShrink: 0,
    },
    stepError: {
        color: theme.colors.sky,
        fontSize: MOBILE_FONT_SIZES.small,
        lineHeight: '17px',
        margin: '8px 0 0',
        letterSpacing: GLOBAL_LETTER_SPACING,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 12,
        padding: '10px 12px',
        borderRadius: 8,
        border: `1px solid ${theme.colors.error}`,
        background: blendHexColor(theme.colors.error, 0.1, theme.colors.cloud),
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DESKTOP_FONT_SIZES.small,
            lineHeight: '18px',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
        },
    },
    stepErrorContent: {
        display: 'flex',
        alignItems: 'center',
        gap: 11,
    },
    stepErrorDesktopBreak: {
        display: 'none',
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            display: 'block',
        },
    },
    stepErrorIcon: {
        width: 24,
        height: 24,
        color: theme.colors.error,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& svg': {
            width: 24,
            height: 24,
        },
        '& path': {
            fill: theme.colors.error,
        },
    },
    stepErrorButton: {
        width: '100%',
        border: `1px solid ${theme.colors.brand}`,
        borderRadius: 999,
        background: theme.colors.cloud,
        color: theme.colors.brand,
        cursor: 'pointer',
        height: 30,
        padding: '0 11px',
        fontSize: MOBILE_FONT_SIZES.main,
        lineHeight: '16px',
        letterSpacing: GLOBAL_LETTER_SPACING,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        transition: '.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        '& svg': {
            width: 18,
            height: 18,
            flexShrink: 0,
        },
        '& path': {
            fill: theme.colors.brand,
        },
        '&:hover, &:active': {
            background: theme.colors.brandTertiary,
        },
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            width: 'auto',
            height: 28,
            fontSize: DESKTOP_FONT_SIZES.small,
            '& svg': {
                width: 16,
                height: 16,
            },
        },
    },
    deleteButton: {
        position: 'absolute',
        outline: `2px solid ${theme.colors.cloud}`,
        top: -10,
        right: -10,
        width: 24,
        height: 24,
        padding: 0,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        borderRadius: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outlineOffset: -2,
        '& svg': {
            width: 20,
            height: 20,
        },
        '& svg > path': {
            fill: `${theme.colors.error} !important`,
        },
        '&:hover': {
            opacity: 0.8,
        },
    },
    moveActions: {
        position: 'relative',
    },
    moveButton: {
        flexShrink: 0,
        borderRadius: 999,
        height: 30,
        padding: '0 11px',
        margin: 0,
        border: `1px solid ${theme.colors.textTertiary}`,
        background: 'transparent',
        color: theme.colors.brand,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        justifyContent: 'center',
        transition: '.2s ease',
        '& span': {
            display: 'block',
            fontSize: MOBILE_FONT_SIZES.main,
            color: theme.colors.brand,
            letterSpacing: GLOBAL_LETTER_SPACING,
            whiteSpace: 'nowrap',
        },
        '& svg': {
            flexShrink: 0,
            width: 18,
            height: 18,
            '& path': {
                fill: theme.colors.brand,
            },
        },
        '&:hover': {
            backgroundColor: theme.colors.brandTertiary,
        },
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            height: 28,
            '& span': {
                fontSize: 13,
            },
            '& svg': {
                width: 16,
                height: 16,
            },
        },
    },
    moveMenu: {
        position: 'absolute',
        top: 30,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 156,
        padding: 4,
        borderRadius: 8,
        background: theme.colors.cloud,
        boxShadow: theme.elevations.dropdown,
        zIndex: theme.zIndex.dropdown,
    },
    moveMenuItem: {
        width: '100%',
        padding: '7px 8px',
        border: 'none',
        borderRadius: 6,
        background: 'transparent',
        color: theme.colors.brand,
        cursor: 'pointer',
        fontSize: MOBILE_FONT_SIZES.small,
        lineHeight: '16px',
        letterSpacing: GLOBAL_LETTER_SPACING,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        transition: '.2s ease',
        '&:hover, &:active': {
            background: theme.colors.brandTertiary,
        },
    },
    codePostfix: {
        fontSize: MOBILE_FONT_SIZES.main,
        color: theme.colors.textPrimary,
        letterSpacing: GLOBAL_LETTER_SPACING,
        transform: 'translateX(-2px)',
    },
    tooltipText: {
        display: 'flex',
        alignItems: 'center',
        fontSize: DESKTOP_FONT_SIZES.main,
    },
    flightNumberTooltip: {
        display: 'flex',
        transform: 'translateX(-2px)',
    },
}), { name: 'flight' });
